export type TOnboardingStepLoader = {
  title: string;
  subtitles: string[];
};

type TOnboardingStep = {
  title: string;
  subtitle: string;
  image: string;
  loader?: TOnboardingStepLoader;
};

export const ONBOARDING_STEPS: TOnboardingStep[] = [
  {
    title: 'Welcome to your style\ndiscovery plan',
    subtitle: 'Personal style grows with practice. This plan helps you bring it into your everyday wardrobe',
    image: 'https://res.cloudinary.com/product-title/image/upload/v1773943833/step-1_va4u6z.webp',
  },
  {
    title: 'Your plan is here to bring clarity',
    subtitle: 'We guide you step by step, so you feel confident in what you wear',
    image: 'https://res.cloudinary.com/product-title/image/upload/v1773943833/step-2_qhod7o.webp',
  },
  {
    title: 'Get outfits that truly fit you',
    subtitle: 'With each day, we learn your style to create outfits that fit perfectly',
    image: 'https://res.cloudinary.com/product-title/image/upload/v1773943833/step-3_cbsjm5.webp',
  },
  {
    title: "Let's begin your first week",
    subtitle: 'Discover your body type, build your style foundation, and get a capsule wardrobe',
    image: 'https://res.cloudinary.com/product-title/image/upload/v1773943833/step-4_jo4smx.webp',
    loader: {
      title: 'Creating your\nstyle discovery plan',
      subtitles: ['Reviewing your answers', 'Analyzing your body type', 'Setting up your 28-day plan'],
    },
  },
  {
    title: 'Ready to start your first day?',
    subtitle: 'With each step, we shape a style that feels like you',
    image: 'https://res.cloudinary.com/product-title/image/upload/v1773943833/step-5_lzh7vz.webp',
  },
];

export const TOTAL_STEPS = ONBOARDING_STEPS.length;
